import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("img", {
    src: require(`@hems/component/resources/images/${_ctx.src}.${_ctx.extension}`)
  }, null, 8, _hoisted_1))
}